import {useCallback} from "react";


export default function useTableSeekerColumns(data, columns) {
	const buildColumns = useCallback(() => columns.map(col => {
		const haveFilters = col?.options?.filter ?? true

		return {
			...col,
			options: {
				... haveFilters && { customFilterListOptions: { render: v => `${col.label}: ${v}` } },
				...col?.options,
				...col?.options?.customBodyRowRender && {
					customBodyRender: (value, tableMeta, updateValue) => {
						const dataIndex = tableMeta.currentTableData[tableMeta.rowIndex].index
						const dataRow = data[dataIndex] || {}
						return col.options.customBodyRowRender(value, dataRow, tableMeta, updateValue)
					}
				},
				...col?.options?.customBodyRowRenderLite && {
					customBodyRenderLite: (dataIndex, rowIndex) => {
						const dataRow = data[dataIndex] || {}
						return col.options.customBodyRowRenderLite(dataRow[col.name], dataRow, dataIndex, rowIndex)
					}
				},
				...col?.options?.headerAlign && {
					setCellHeaderProps: columnMeta => {
						const headerProps = col?.options?.setCellHeaderProps ? col.options.setCellHeaderProps(columnMeta) : {}
						return {
							...headerProps,
							sx: {
								...headerProps?.sx,
								span: {
									justifyContent: col.options.headerAlign,
									...headerProps?.sx?.span
								},
								div: {
									textAlign: col.options.headerAlign,
									...headerProps?.sx?.div
								}
							},
						}
					}
				}
			}
		}
	}), [JSON.stringify(columns), JSON.stringify(data)])

	return {
		buildColumns
	}
}
